import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { selectorIsRequirementReadyToUploadFile } from "../../../../selectors/selectorIsRequirementReadyToUploadFile";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";

export const getPayerSharedFileRequirementIsUploadAvailable = (
  requirement: IRequirementResponse,
  sharedFile: ISharedFileRequestResponse | undefined
): boolean => {
  return selectorIsRequirementReadyToUploadFile(requirement, sharedFile);
};
